(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/handle-pay-response.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/handle-pay-response.js');

'use strict';

function isGamePackageClosed() {
  return svs.gamePackage.redux.store.getState().gamePackage.packageIsClosed;
}
function currentDrawNumber(productItsId) {
  const draws = svs.gamePackage.redux.store.getState().numbergames.draws;
  const draw = draws.find(draw => draw.productItsId === productItsId);
  return draw.drawNumber;
}
function handlePayResponse(_ref) {
  let {
    next,
    cancel,
    regWagerResults,
    wagers,
    successfulWagers = [],
    failedWagers = []
  } = _ref;
  const incompleteWagers = [];
  for (let i = 0, len = regWagerResults.length; i < len; i++) {
    const {
      status,
      regWagerResult,
      tpError
    } = regWagerResults[i];
    const wager = wagers[wagers.length - (regWagerResults.length - i)];
    if (status === 'FAILURE') {
      const {
        productId,
        drawNum
      } = wager.bets[0];
      if (i === 0 && regWagerResults.length === wagers.length) {
        if (isGamePackageClosed()) {
          svs.gamePackage.logger.info('GamePackage was closed before payment.');
          return cancel();
        }
        if (currentDrawNumber(productId) > drawNum) {
          svs.gamePackage.logger.info("Draw for ".concat(productId, " was closed before payment."));
          return next({
            drawIsClosed: true,
            closedProductItsId: productId
          });
        }
      }
      failedWagers.push({
        tpError,
        wager
      });
      svs.gamePackage.logger.warn("Failed to pay ".concat(productId, ". Reason ").concat(tpError.errDesc, "."));
    }
    if (status === 'INCOMPLETE') {
      incompleteWagers.push(wager);
    }
    if (status === 'SUCCESS') {
      successfulWagers.push({
        wagerClientSerial: regWagerResult.wagerClientSerial,
        wagerAmounts: regWagerResult.wagerAmounts,
        wager
      });
    }
  }
  if (!successfulWagers.length && !incompleteWagers.length) {
    return svs.tur.apierrors.showErrorMessage({
      response: failedWagers[0].tpError.errCode,
      onConfirm: cancel
    });
  }
  if (incompleteWagers.length) {
    return next({
      incompleteWagers,
      successfulWagers,
      failedWagers
    });
  }
  next({
    successfulWagers,
    failedWagers
  });
}
svs.gamePackage.pay.handlePayResponse = handlePayResponse;

 })(window);